import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-topbar.detail",
  "use": "icon-topbar.detail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-topbar.detail\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z\" />\n<circle cx=\"8\" cy=\"4.75\" r=\"0.75\" />\n<rect x=\"7.5\" y=\"6.5\" width=\"1\" height=\"6\" rx=\"0.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol